import { MasterTranslation } from '@/constants';
import { useGlobalState } from '@/hooks';
import { SectionContainer } from '@/modules/pmt/components/SectionContainer';
import { ShipmentLogo } from '@/modules/pmt/components/ShipmentLogo';
import type { ICarrier } from '@/modules/pmt/interfaces';
import { getCarrierUrl } from '@/modules/pmt/utils';
import { gtmClickCourierSite } from '@/utils';
import { TRACKING_DETAILS_SECTIONS } from '../../constants';
import {
  TrackingCarrierHyperlink,
  TrackingCarrierHyperlinkWrapper,
  TrackingCarrierListWrapper,
  TrackingCarrierName,
  TrackingCarrierPhone,
  TrackingCarrierWebsite,
  TrackingCarrierWrapper,
} from './TrackingCarrierSection.styles';

interface ITrackingCarrierSectionProps {
  parcelId?: string;
  carrierList: ICarrier[];
}

export const TrackingCarrierSection: React.FC<ITrackingCarrierSectionProps> = ({ parcelId, carrierList }) => {
  const { t } = useGlobalState();

  if (!parcelId || !carrierList.length) return null;

  const renderCarrierPhone = (carrier: ICarrier) => {
    if (!carrier.csPhone) return '-';

    return <TrackingCarrierHyperlink href={`tel:${carrier.csPhone}`}>{carrier.csPhone}</TrackingCarrierHyperlink>;
  };

  const renderCarrierWebsite = (carrier: ICarrier) => {
    const url = getCarrierUrl({ carrier, parcelId });

    if (!url) return '-';

    return (
      <TrackingCarrierWebsite onClick={() => url && gtmClickCourierSite(url)} href={url} target='_blank' rel='noopener'>
        {carrier.name} {t(MasterTranslation.Website)}
      </TrackingCarrierWebsite>
    );
  };

  return (
    <SectionContainer>
      <SectionContainer.Header
        gutterBottom
        sectionIcon={TRACKING_DETAILS_SECTIONS.Carrier.icon}
        sectionTitle={TRACKING_DETAILS_SECTIONS.Carrier.titleKey}
      />
      <TrackingCarrierListWrapper>
        {carrierList.map((carrier) => {
          return (
            <TrackingCarrierWrapper key={carrier.id} id={carrier.id}>
              <ShipmentLogo variant='carrier' carrierLogo={carrier.logo} carrierName={carrier.name} />
              <div>
                <TrackingCarrierName>{carrier.name}</TrackingCarrierName>
                <TrackingCarrierPhone>
                  <img src='/images/icons/phone.svg' alt='phone' />
                  {renderCarrierPhone(carrier)}
                </TrackingCarrierPhone>
                <TrackingCarrierHyperlinkWrapper>
                  <img src='/images/icons/language.svg' alt='language' />
                  {renderCarrierWebsite(carrier)}
                </TrackingCarrierHyperlinkWrapper>
              </div>
            </TrackingCarrierWrapper>
          );
        })}
      </TrackingCarrierListWrapper>
    </SectionContainer>
  );
};
